import { Component, Input, OnInit } from "@angular/core";
import { finalize } from "rxjs/operators";
import { environment as appEnv } from "../../../environments/environment";
import { ProjectDigestsService } from "../../models/project-digests.service";
import { sampleDigestStats } from "../sample-data/digest-stats";

@Component({
  selector: "ab-digest-stats",
  templateUrl: "./digest-stats.component.html",
})
export class DigestStatsComponent implements OnInit {
  @Input() public project: any;
  @Input() public digestId: number;
  @Input() public featureDisabled: boolean;
  @Input() public missingErrorData: boolean;
  @Input() public missingDeployData: boolean;
  @Input() public missingPerformanceData: boolean;

  public appEnv = appEnv;
  public loading: boolean;
  public digestStats: any;

  constructor(private projectDigestsService: ProjectDigestsService) {}

  public ngOnInit() {
    if (this.featureDisabled) {
      this.digestStats = sampleDigestStats;
      this.missingErrorData = false;
      this.missingDeployData = false;
      this.missingPerformanceData = false;
      return;
    }

    this.loading = true;

    this.projectDigestsService
      .comparison({
        projectId: this.project.id,
        projectDigestId: this.digestId,
      })
      .pipe(
        finalize(() => {
          this.loading = false;
        }),
      )
      .subscribe((data: any) => {
        this.digestStats = data;
      });
  }
}
